<template>
  <div class="counter">
    <span :class="{minus: true, disable: value === min}" @click="minus()">-</span>
    <span class="number">{{value}}</span>
    <span :class="{add: true, disable: value === max}" @click="add()">+</span>
  </div>
</template>

<script>
export default {
  name: 'counter',
  data() {
    return {
      value: 0
    }
  },
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    now: {
      type: Number
    },
    name: {
      type: String,
      required: true
    }
    // getValue: {
    //   type: Function,
    //   required: true
    // },
  },
  mounted() {
    this.value = this.now || this.min
  },
  methods: {
    add() {
      if (this.value >= this.max) return

      this.value += 1
      this.send()
    },
    minus() {
      if (this.value <= this.min) return

      this.value -= 1
      this.send()
    },
    send() {
      this.$emit('getValue', {name: this.name, value: this.value})
    }
  }
}
</script>

<style lang="less" scoped>
 @import '../assets/css/global.less';

  .counter {
    width: 110px;
    height: 30px;
    display: flex;
    color: @dark;
    font-size: 14px;
    line-height: 30px;
    .minus {
      width: 30px;
      text-align: center;
      line-height: inherit;
      height: 100%;
      border-radius:4px 0 0 4px;
      border: 1px solid #dcdcdc;
      cursor: pointer;
    }
    .number {
      width: 50px;
      text-align: center;
      line-height: inherit;
      height: 100%;
      border-top: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
    }
    .add {
      width: 30px;
      height: 100%;
      text-align: center;
      line-height: inherit;
      border-radius:0 4px 4px 0;
      border: 1px solid #dcdcdc;
      cursor: pointer;
    }
    .disable {
      color: @dateColor;
    }
  }
</style>
